import * as React from 'react';
import { Switch as SwitchPrimitives } from 'radix-ui';
import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full ring-1 ring-ui-bevel transition duration-150 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ui-separator focus-visible:ring-offset-0 focus-visible:duration-150 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-highlight-base data-[state=unchecked]:bg-ui-bevel aria-invalid:ring-red-500! aria-invalid:focus-visible:ring-red-500!',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-input-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-[2px] ',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
